module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('a', {
    attrs: {
      "id": "title2"
    }
  }, [_c('h1', {
    staticClass: "title"
  }, [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('h1', {
    staticClass: "subtitle"
  }, [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("19th Century")])])]), _vm._v(" "), _c('p', {
    staticClass: "p-c"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Pugilists, Promoters and Politicos")])])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_vm._v("Boxing in Chicago really began after the Civil War. The town was booming with industry and the population was soaring, and fighters came from other parts of the country to compete, even though the sport was illegal in Chicago as well as the entire state of Illinois.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In the beginning, matches were held in the back rooms of saloons, in barns, and on the beaches of Lake Michigan. These were both bare-knuckle and glove contests. Some were fights to the finish while others were a specified number of rounds. These were brutal affairs with prize money divided unequally; the larger take went to the winners and smaller amounts to the losers. Some were “winner take all” contests, and the wagering was tremendous.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("The foremost Promoter was a tough and resourceful Irishman named Dominick O’Malley. He held fights on the sneak, and if the heat was on in the city, he would stage matches across the state line in Roby, Indiana, or on a nearby beach in Michigan.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In Chicago, O’Malley’s principle supporter was the gambling boss Mike McDonald, a boxing fan and sometime referee. When Chicago held its first World’s Fair in 1893, Mayor Carter Harrison, Sr. permitted fights to be held openly with paid admissions at spacious Battery D Amory Arena. McDonald selected the promoter, a wily gambler and friend named Parson Davies. Davies was not a clergy man, he just dressed like one.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Boxing became an “on-again off-again” matter under Mayor Carter Harrison, Sr. and his son and successor Carter Harrison, Jr., both of whom were assassinated while in office. Still, arenas sprang up around the city. Among them were Apollo Hall at 12th and Blue Island; McGurns, at Davison and Wells; and the American, at 31st and Indiana. And many great champions like Jack McAllife, George Dixon, Kid Lavigne, the original Joe Walcott, Tommy Ryan, and Kid McCoy came to fight in Chicago. (McCoy was knocked out in one round by a second-rater named Jack McCormick in one of the era’s biggest upsets.)")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("But because boxing matches in Chicago were limited to six rounds, big money fights of 20 and 25 rounds went to the West Coast. When Lou Houseman became the top Chicago promoter, after Parson Davies headed west, several bills to legalize boxing and permit longer fights were introduced in the Illinois Legislature; but they were always defeated. Not until the 1893 Columbian Exposition would things really look up for Chicago boxing.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "44%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0007.jpg",
      "src": "images/e9781439614785_i0007.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("PROFESSOR MIKE DONOVAN.")]), _vm._v(" Mike Donovan was born in Chicago in 1842. Still a teenager when the Civil War started in 1861, he joined the 71st Illinois Volunteers, saw action with this regiment in all their major battles, and was decorated for bravery. Mike had been taught to box before the war by his brother, Jerry, who was a professional. He continued to perfect his skills whenever he could find an opponent among his fellow soldiers. Size was not important to Donovan, who never weighed more than 160 pounds. He had both speed and a powerful punch, and the bigger soldiers proved easy prey. Mike was also a very clever boxer with a strong defense, difficult to hit cleanly.")])])])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("After the war, Donovan began boxing professionally and soon became the middleweight champion of America. He could box 60 or 90 rounds bare knuckle, or go 10 rounds wearing gloves; either way, he beat all the contenders. He even fought a pair of three-round exhibitions to a draw with future heavyweight legend John L. Sullivan, who outweighed him by 50 pounds. In a career that lasted until 1891, Donovan won 24 of his 33 matches, fought to seven draws, and lost only two fights—both on fouls.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("After retiring from the ring, he became a boxing instructor at the New York Athletic Club, a post he held for 38 years. Future President Theodore Roosevelt was one of his students, and Donovan was later a frequent visitor to the White House, where he would spar with the Chief Executive.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("Donovan died in 1918. His son, Arthur, who boxed professionally and also served as his father’s assistant, spent 50 years as a coach at the NYAC. Arthur Donovan also became the most famous referee in New York City. His son, Artie Donovan, was a great football player with the champion Baltimore Colts and later became an author and television personality.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "44%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0008.jpg",
      "src": "images/e9781439614785_i0008.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HARRY GILMORE—MAKER OF CHAMPIONS.")]), _vm._v(" Gilmore was Chicago boxing’s greatest teacher. His pupils included champions and top contenders. "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Right:")]), _vm._v(" Gilmore was a good fighter in his own right and at one time in the 1870s claimed the featherweight title. After running out of opponents in that division, he challenged undefeated Jack McAuliffe for the lightweight crown. On January 13, 1887, after a furious fight, Harry was stopped in the 28th round. Thereafter, he devoted his himself to his protégés and his boxing academy at McGurn’s Handball Court. (Photo from Harry Shaffer.) "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Below:")]), _vm._v(" Gilmore (front row, center) is seen with his top pupils, clockwise from lower left, Jimmy Barry, Frank Gerrard, Tommy White, George Kirwin, Eddie Santry, and Harry Forbes.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0009.jpg",
      "src": "images/e9781439614785_i0009.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "45%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0010.jpg",
      "src": "images/e9781439614785_i0010.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("JIMMY BARRY—UNDEFEATED CHAMPION.")]), _vm._v(" Jimmy, called the “Little Tiger,” was the first of Chicago’s five bantamweight champions and perhaps the best. He was born and raised on the Chicago’s Southside. A protégé of Harry Gilmore, the hard-hitting Barry turned pro in 1891 and quickly became a Chicago fan favorite. He hit with surprising power for a boy who only weighed a little over a 100 pounds. In a just few years, he had taken on and knocked out most of the top fighters in his weight class , and many who were heavier. Finally, on September 15, 1894, he challenged the highly regarded Casper Leon in Lamont, Illinois, and knocked him out in 28 rounds to claim the world 118-pound title.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-indent"
  }, [_c('span', [_vm._v("In 1897, after continuing his winning ways for three years, Jimmy Barry sailed off to London, England, to meet the British champion, Walter Croot, in a December 6 match to determine the undisputed bantamweight champion of the world. Croot was knocked out in the 20th round. He suffered a brain injury and died. The crestfallen Barry was exonerated by the coroner’s jury, but was never the same in the ring again. Afraid of causing serious injury, he held back on his punches and never scored another knockout. (He had KO’d an amazing 38 out of 60 bouts.) He retired, undefeated, in 1899. Barry died in April of 1943, in Chicago, at 73 years of age.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "45%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0011.jpg",
      "src": "images/e9781439614785_i0011.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("ST. PADDY’S DAY BRAWL.")]), _vm._v(" Jimmy Barry (right) squared off against fellow Irishman, Johmmy Conners, on Saint Patrick’s Day, 1898, at Chicago’s Irish Hall. Barry won the six-round decision.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "72%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0012.jpg",
      "src": "images/e9781439614785_i0012.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("TOMMY WHITE.")]), _vm._v(" White (left) squares off against Billy Brennan on Chicago’s lake shore. Looking on inside the ring is Malachi Hogan—referee, saloon keeper, and popular sports writer. Tommy was the first of Harry Gilmore’s pupils to establish a national reputation. At the tender age of 16, he could hold his own with the best featherweights, and he claimed the title. Wearing 2-ounce gloves, White took part in one of the longest bouts in history—a match to the finish against Danny Daly that went 91 rounds, lasted six hours and ended in a draw. A very tough little Irishman, he also fought to a draw with the great George Dixon, but was stopped in a match with the murderous champion, Terry McGovern. Tommy then retired and went to work for the post office. He also became a trainer and worked for the Catholic Youth Organiztion (CYO).")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image_text"
  }, [_c('div', {
    staticClass: "image_text",
    staticStyle: {
      "width": "68%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0013.jpg",
      "src": "images/e9781439614785_i0013.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("HARRY FORBES.")]), _vm._v(" Harry, a tough little Irishman born in Rockford, Illinois, in 1879, moved to Chicago and launched a busy boxing career in 1897. He was another protégé of Harry Gilmore and had an amazing 130 bouts against the best little men of his day, often in his opponents’ home towns. On April 2, 1901, in his fourth meeting with Casper Leon, Forbes won a 20-round decision in Memphis and with it took the vacant bantamweight title. He beat future featherweight champ Abe Attell the same year, winning on points after 15 rounds, and defended his title four times before losing it to Frankie Neil (who he had previously defeated) by a second-round knockout in 1903. (Harry’s brother Clarence, another good little fighter, had been knocked out by Frankie Neil earlier that year to earn Neil the rematch with Harry.) Forbes fought until 1913, and afterward had a good job for years at City Hall. He also became a boxing promoter. Harry Forbes died at the age of 67 in Chicago in December, 1947.")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "43%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0014.jpg",
      "src": "images/e9781439614785_i0014.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_c('span', [_c('em', {
    staticClass: "i"
  }, [_vm._v("Opposite:")]), _vm._v(" "), _c('strong', {
    staticClass: "b"
  }, [_vm._v("HAIRPIN HARRY HARRIS—CHICAGO’S FIRST JEWISH CHAMPION.")]), _vm._v(" Harry Harris and his twin brother, Sammy, were born in 1880 and raised on Chicago’s Southside, where they took up boxing at an early age. Sammy was good and was making the grade, but died young after a brief professional career. Harry, who turned pro at the age of 15, came under the wing of the famous Kid McCoy, who taught him the tricks of the trade, including the celebrated “Corkskrew Punch.” As bantamweight who stood 5-feet-8 and had an unusually long reach, Harris was soon beating all the local boys and was finally matched with undefeated world champion Jimmy Barry. Harris appeared to be the clear winner, but the match was declared a draw and Barry announced his retirement as the unbeaten titleholder. Not discouraged, Harry traveled to London, England, where he beat the Empire champ, Pedlar Palmer, and gained recognition as the 118-pound king. He retired as champ in 1907, took a position managing theatres for A.L. Erlanger, and married famous actress Desiree Lazard. Harris pursued a seat on the New York Stock Exchange, which he joined and in which he was very successful, retiring a wealthy man in 1930. As a member of the New York Athletic Club, he gave a young Gene Tunney some tips on the manly art. Harry Harris died June 5, 1959, at the age of 78.")])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "39%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0015.jpg",
      "src": "images/e9781439614785_i0015.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("EDDIE SANTRY—BOXING TO POLITICS.")]), _vm._v(" Eddie Santry was another of Harry Gilmore’s Boxing pupils. He was a classy featherweight who could outpoint anyone near his weight on a good day. But he was not particularly rugged and was knocked out in several major bouts. In 1899, Santry almost won the world title when he fought to a 20-round draw with the great George Dixon. In his next fight, he knocked out Ben Jordon of England to capture the British title. In 1900, in Chicago, he was KO’d by “Terrible” Terry McGovern in another try for the featherweight crown. He fought for several more years, winning most of his contests but getting knocked out in the big ones. He retired from the ring in 1911 to enter politics and was elected to the Illinois State Legislature. Santry was very popular and was re-elected several times from his district. He was still in office when he died in 1919, just 43 years old. (Photo courtesy of Harry Shaffer.)")])])])]), _vm._v(" "), _c('div', {
    staticClass: "illustype_image"
  }, [_c('div', {
    staticClass: "image",
    staticStyle: {
      "width": "41%"
    }
  }, [_c('img', {
    attrs: {
      "alt": "e9781439614785_i0016.jpg",
      "src": "images/e9781439614785_i0016.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('p', {
    staticClass: "p"
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("DEATH IN THE RING.")]), _vm._v(" Dutch Neal (left) was killed while sparring with Harry Peppers in a Chicago gym, in 1900. It happened a short time before the infamous Gans-McGovern “fight” in November in Chicago. The man on the right is manager James Courtney. (Photo courtesy of Bob Carson.)")])])])])])]), _c('a', {
    attrs: {
      "id": "title2"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a35de20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781439614785_c01.vue
// module id = 84
// module chunks = 0